module.exports = __webpack_public_path__ + "img/1484752775.ffdcd8a4.jpg";